<template>
  <div class="part-substitute-list" style="position: relative;">
    <a @click="showModal = true" style="position: absolute; top: -40px; right: 0;">{{ $t('part.substitute_manage') }}</a>
    <Spin v-if="loading"></Spin>
    <div v-else>
      <PartSubstituteCardList :items="substituteItems" :icons="icons"></PartSubstituteCardList>
      <Modal :z-index="1000" v-model="showModal" title="Manage part substitutes" width="70%" mask>
        <PartSubstituteTable
          :currentPartId="partId"
          :currentPart="currentPart"
          :items="substituteItems"
          :substituteCollectionIds="substituteCollectionIds"
          :icons="icons">
        </PartSubstituteTable>
      </Modal>
    </div>
  </div>
</template>

<script>
import PartSubstituteCardList from './views/part-substitute-card-list'
import PartSubstituteTable from './views/part-substitute-table'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'PartSubstituteList',
  components: {
    PartSubstituteCardList,
    PartSubstituteTable
  },
  props: {
    partId: {
      type: Number,
      require: true
    },
    currentPart: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      showModal: false,
      icons: {
        'mutual_substitute': 'md-swap',
        'unilateral_substitute': 'md-arrow-forward'
      }
    }
  },
  computed: {
    ...mapGetters(['getSubstituteCollectionsByPart']),
    /**
     * The object stores the substitute type and its id, so when we add item to the subsitute collection
     * it can be quickly accessing the substitute collection id using this variable.
     *
     * Example, substituteCollectionIds:
     *  { mutual_subsitutute: 149, unilateral_subsitutute: 151 }
     *
     * The create the object, we firstly, load current part's substitute collections, see mounted(),
     * and extract the part's substutite collections.
     */
    substituteCollectionIds () {
      let data = this.getSubstituteCollectionsByPart(this.partId)
      return _.reduce(data, function (h, v) {
        return Object.assign({}, h, { [v.substitution_type]: v.id })
      }, {})
    },
    /**
     * The data loaded from state is a structure of such as below:
     * [
     *   { collect1 : { items } },
     *   { collect2: { items }}
     * ]
     *
     * Will be firstly merged as =>
     * [ ...items, ...items ]
     *
     * In order to display first collect and second collect in different group, we extract the collect's
     * substitute_type as group key.
     */
    substituteItems () {
      let data = this.getSubstituteCollectionsByPart(this.partId)

      if (data.length > 0) {
        let itemsFlatten = _.reduce(data, (holder, collect) => {
          collect.items.forEach((item) => {
            // The current part will be hidden from the items collection.
            if (item.manufacturer_part_id !== this.partId) {
              holder.push(Object.assign({}, item, { substitute_type: collect.substitution_type }))
            }
          })
          return holder
        }, [])

        return _.groupBy(_.sortBy(itemsFlatten, 'manufacturer_part.part_identity'), 'substitute_type')
      }

      return {}
    }
  },
  methods: mapActions(['loadPartSubstituteCollections']),
  mounted () {
    this.loading = true
    this.loadPartSubstituteCollections(this.partId).finally(() => { this.loading = false })
  }
}
</script>

<style lang="less">
.part-substitute-list {
  .part-info--card:nth-child(2n) {
    background-color: #f8f8f9;
  }

  .ivu-row {
    padding: 8px;
  }
  .ivu-tooltip {
    font-weight: normal;
  }
}
</style>
